/**
 * Iterates @param arrUsers to check for @param user existence.
 * Existence check performed against property `Value` of property `F_ESO_ID` of property `Cells` of index.
 *
 * @function
 * @param {string} user `dbo.T_ESO.F_ESO_ID` of user of interest.
 * @param {Object[]} arrUsers array of user output to be rendered in `DataTable`.
 * @returns {boolean} indication whether user in user array.
 */
export const checkUsersForUser = (arrUsers, user) => {
	const key = 'F_ESO_ID';
	return Array.isArray(arrUsers)
		? arrUsers.some(
				el => el.Cells && el.Cells[key] && el.Cells[key].Value === user
		  )
		: false;
};
